
<template>
<div id="layout_apendices" >
    <div>
        <v-breadcrumbs :items="parametrosAP27.breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" :title="parametrosAP27.title" class="px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered" :exportFields="parametros.camposexcel" :name="parametros.title + '.xlsx'" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccessAP27" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="parametrosAP27.camposLayout" :exportFields="parametrosAP27.encabezadoLayout" :name="'Layout ' + parametrosAP27.title + '.xlsx'" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModalAP27(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                    </v-card-actions>                            
                    <v-client-table ref="vuetable" :data="datosAP27.items" :columns="parametrosAP27.columns" :options="parametrosAP27.options" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                        </template>

                        <template slot="actions" slot-scope="props" >
                            <v-speed-dial v-if="((id_cliente == 0 && props.row.cliente==null) || (props.row.cliente == id_cliente))" direction="left" :open-on-hover="true" >
                                <v-btn slot="activator" x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>

                                <v-btn x-small fab dark color="blue" @click.native="getRegistroAP27(props.row.id)" title="Editar Registro" v-tippy>
                                    <v-icon>edit</v-icon>
                                </v-btn>
                                <v-btn x-small fab dark color="pink" @click.native="deleteRegistroAP27(props.row.id)" title="Eliminar Registro" v-tippy>
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-speed-dial>
                        </template>
                    </v-client-table>
                    
                    
                    <v-dialog v-model="modalAP27" max-width="50%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-power-titulo :icon="update ? 'edit' : 'add'" :title="update ? 'Actualizar Registro' : 'Nuevo Registro'" tipo="modal" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modalAP27 = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-form ref="form" lazy-validation>
                                <v-card-text>
                                    <v-container grid-list-md text-xs-center @keyup.enter="guardarAP27()" >
                                        <v-layout row wrap v-for="(item, index) in this.parametrosAP27.form" :key="index" >
                                            <v-flex s12 m6 l6>
                                                <v-text-field :name="item" :label="item.label" type="text" v-model="item.value" @input="item.value = item.value.toUpperCase()" :rules="item.requiered ? [rules.required] : []" :maxlength="item.maxlen" ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-form>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modalAP27 = false" >
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-btn color="success" :loading="loading" @click.native="guardarAP27()" >
                                    <v-icon>done</v-icon>
                                    {{ update ? "Actualizar" : "Guardar" }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>                    
                    
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    data: () => ({
        fab: false,        
        name: "datagrid",
        importData: [],
        show_loading: true,
        loading: false,
        modalAP27: false,                
        update: false,
        url_active: location.href,
        id_cliente: 0,
        editable: true,
        datosAP27: {
            items: []
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        parametros: {},
        clientes: [],
        parametrosAP27: {
            visible:true,
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 27,
            title: "CLAVES E IDENTIFICADORES ACTIVO FIJO",
            columns: [
                "clave",
                "descripcion",
                "identificadores",                
                "actions"
            ],
            options: {
                filterable: [
                    "clave",
                    "descripcion",
                    "identificadores",                                
                ],
                sortable: [
                    "clave",
                    "descripcion",
                    "identificadores",                    
                ],

                headings: {
                    clave: "Clave de Pedimento",
                    descripcion: "Descripción",
                    identificadores: "Identificadores en Complemento",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Identificadores: "identificadores",                
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                identificadores: "identificadores",                
            },
            camposLayout: [{
                clave: "[Clave de Pedimento]",
                descripcion: "[Descripción de la Clave del Pedimento y sus Identificadores]",
                identificadores: "[Identificadores separados por comas]",                
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                identificadores: "",                
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave de Pedimento",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 255
                },
                identificadores: {
                    requiered: false,
                    label: "Identificadores separados por comas (Dejar vacío si aplica para todos)",
                    value: "",
                    maxlen: 250
                },                
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apéndices",
                    disabled: true,
                    to: ""
                }
            ]
        },        
    }),
    components: {
        "v-power-titulo": powerTitulo,
        "v-menu-lateral-apendice": menuLateral
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.datosAP27.items;
            }
        },        
    },
    methods: {
        openModalAP27: function (type) {
            if (type === 1) {
                this.limpiarModelAP27();
                this.update = false;
            } else {
                this.update = true;
            }
            this.modalAP27 = true;
        },
        limpiarModelAP27: function () {
            for (var k in this.parametrosAP27.model) {
                this.parametrosAP27.model[k] = "";
            }
            for (var k in this.parametrosAP27.model) {
                if (Object.keys(this.parametrosAP27.form).includes(k))
                    this.parametrosAP27.form[k].value = "";
            }            
        },
        
        guardarAP27() {
            var datos = this.parametrosAP27.model;
            datos["tabla"] = this.parametrosAP27.tabla;
            let id_cliente = this.$local_storage.get("id_cliente");
            var obj = this.parametrosAP27.form;
            for (var [key, valores] of Object.entries(obj)) {
                datos[key] = valores.value;
                datos["cliente"] = id_cliente == 0 ? null : id_cliente;
            }

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.parametrosAP27.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        //console.log(error);
                    })
                    .then(() => {
                        this.cargarAP27();
                        this.$root.$dialogLoader.hide();
                        this.modalAP27 = false;
                    });
            }
        },        
        cargarAP27: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');            
            var datos = {
                tabla: this.parametrosAP27.tabla,                
            };            

            axios
                .post(this.$hostname + this.parametrosAP27.url_list, datos)                                       
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosAP27.items = res.data;
                        var self = this;
                        var tipoUsuario = this.$local_storage.get("tipo_usuario");                        
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },        
        getRegistroAP27: function (id_registro) {
            let tabla = this.parametrosAP27.tabla;
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: tabla
                    }
                })
                .then(response => {
                    this.parametrosAP27.model = response.data;
                    var obj = response.data;
                    for (var [key, value] of Object.entries(obj)) {
                        if (Object.keys(this.parametrosAP27.form).includes(key))
                            this.parametrosAP27.form[key].value = value;
                    }
                    this.openModalAP27(2); //ACTUALIZAR
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        deleteRegistroAP27: function (id_registro) {
            let tabla = this.parametrosAP27.tabla;
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: tabla
                            }
                        })
                        .then(response => {
                            this.cargarAP27();
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        handleSuccessAP27({
            results,
            header
        }) {
            
            this.importData = results;

            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let tabla = this.parametrosAP27.tabla;
            axios
                .post(this.URL + "importar_apendice/?tabla=" + tabla, this.importData)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "Los datos se guardaron correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    var errores = "";
                    if (typeof err.response.data != "undefined") {
                        for (var i = 0; i < err.response.data.length; i++) {
                            Object.keys(err.response.data[i]).forEach(function (key) {
                                errores +=
                                    "Fila " +
                                    (i + 2) +
                                    " => " +
                                    key +
                                    ": " +
                                    err.response.data[i][key];
                                errores += "<br>";
                            });
                        }
                    }
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                        footer: errores
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarAP27();
                    
                });
        },        

    }, //methods

    created: function () {
        this.id_cliente = this.$local_storage.get("id_cliente");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");        
                
        this.URL = this.$hostname + this.parametrosAP27.url_actions;                    
                       
        if (this.id_cliente > 0) {
            this.editable = false;
            //AP27
            delete this.parametrosAP27.options.headings["actions"];
            var key = 0;
            for (var k in this.parametrosAP27.columns) {
                if (this.parametrosAP27.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.parametrosAP27.columns[key];            
        }
        this.cargarAP27();        
    }
};
</script>

<style>
.VueTables__limit {
    display: none;
}
</style>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
  font-size: x-small !important;
}
</style>
